import { render, staticRenderFns } from "./ActionEvents.vue?vue&type=template&id=6bed28ac&scoped=true"
import script from "./ActionEvents.vue?vue&type=script&lang=js"
export * from "./ActionEvents.vue?vue&type=script&lang=js"
import style0 from "./ActionEvents.vue?vue&type=style&index=0&id=6bed28ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bed28ac",
  null
  
)

export default component.exports